import React from 'react'

function getRandomNumberInRange(min, max, totalNumbers) {
    const uniqueNumbers = new Set();
  
    while (uniqueNumbers.size < totalNumbers) {
      const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
      uniqueNumbers.add(randomNum);
    }
  
    return [...uniqueNumbers];
  }

  
function applyBingoRules(rows, cols, ticket) {
    for (let row = 0; row < rows; row++) {
      const nullPositions = getRandomNumberInRange(0, 8, 4);
      nullPositions.forEach((col) => {
        ticket[row][col] = null;
      });
    }
  
    return ticket;
  }

  
export function generateBingoLotteryTicket(gridSizeStr, maxNumber) {
    const [rows, cols] = gridSizeStr.split('x').map(Number);
    const maxPerColumn = Math.floor(maxNumber / cols);
    const ticket = [];
  
    for (let col = 0; col < cols; col++) {
      const min = col * maxPerColumn + 1;
      const max = (col + 1) * maxPerColumn;
  
      const colNumbers = getRandomNumberInRange(min, max, rows);
      ticket.push(colNumbers);
    }
  
    // Transpose to make it row-wise
    const formattedTicket = ticket[0].map((_, i) => ticket.map(col => col[i]));
    return rows === 3 && cols === 9 ? applyBingoRules(rows, cols, formattedTicket) : formattedTicket;
  }
